import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { RedirectToDjango } from '@saucelabs/sl-container-experiment';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importAdminUserDashboard = () => import(/* webpackChunkName: "jobs-admin-user-dashboard" */ './containers/AdminUserDashboardContainer');

const AdminUserDashboardRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={importAdminUserDashboard}
        path={`${match.url}/:username/dashboard/:tabName?`}
      />
      {/* Redirect if there no Route match to switch to Django app */}
      <Route component={RedirectToDjango} />
    </Switch>
  </LoginRequiredContainer>
);

AdminUserDashboardRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};


export default AdminUserDashboardRoutes;
export { AdminUserDashboardRoutes };
